import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../../Text/Text"


interface OwnProps {
  cityRegionPostal: string;
  comingSoon?: string;
  googleMapEmbedLink?: string;
  location: string;
  streetAddress: string;
  todaysHours?: {
    opensAt?: string;
    closesAt?: string
  }
  url: string;
  yearOpening?: string;
}

export type LocationItemProps = OwnProps

export const LocationItem: React.FC<LocationItemProps> = ({
  cityRegionPostal,
  comingSoon,
  googleMapEmbedLink,
  location,
  streetAddress,
  todaysHours,
  url,
  yearOpening
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.location_item",
  });

  return (
    <div className="bg-light-wool mt-5 p-4 md:mt-0">
      {googleMapEmbedLink && (
        <div className="mb-5 justify-center">
          <iframe className="mx-auto w-full" src={googleMapEmbedLink} width="355" height="190" loading="lazy"></iframe>
        </div>
      )}
      <Text variant="small-subheader">{location}</Text>
      {comingSoon && (
        <Text variant="small-subheader">{yearOpening ? `(${t("coming_soon_with_year", { yearOpening })})` : `(${t("coming_soon")}`}</Text>
      )}
      <div className="mt-4">
        <Text variant="body">{streetAddress}</Text>
        <Text variant="body">{cityRegionPostal}</Text>
      </div>
      {todaysHours && !comingSoon && (
        <div className="mt-4">
          <div className="inline-block bg-turquoise text-white px-2.5 py-1 rounded-3xl">
            <Text variant="small-caption">{todaysHours?.opensAt && todaysHours?.opensAt !== "Closed" ? `${t("open_till")} ${todaysHours?.closesAt}` : t("closed_today")}</Text>
          </div>
        </div>
      )}
      <div className="mt-4">
        <Text variant="text-link"><a className="uppercase" href={url}>{t("learn_more")}</a></Text>
      </div>
    </div>
  )
}
